module.exports = __webpack_public_path__ + "static/img/header.97c59bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/header.jpg
// module id = oYm8
// module chunks = 25